module.exports = __webpack_public_path__ + "img/CCRM-Fair-Housing-wht-150x150.19e4e174.png";